
<div class="base-app">
  <!-- App common header -->
  <app-header></app-header>

  <div [ngClass]="fromPage? proxy_temp : 'body-proxy'">
    <!-- <div [ngClass]="class"></div> -->
    <!-- App body loads here -->
    <router-outlet></router-outlet>
  </div>
</div>

